<div *ngIf="!isLoading" class="container mt-4" style="max-width: 500px;">
  <!-- <p class="edit_text" *ngIf="user.isNew" translate>New Company Admin</p>
  <p class="edit_text" *ngIf="!user.isNew" translate>Edit Company Admin</p> -->
  <div class="row">
    <div>
      <form #userForm="ngForm" class="form-vehicle">
        <!-- Name -->
        <div class="form-group mb-2">
          <label translate>global.name</label>
          <input type="text" #name="ngModel" autocomplete="off" required [ngModel]="user?.name" class="form-control"
            [class.is-invalid]="name.invalid && name.touched" name="name">
        </div>

        <!-- Email -->
        <div class="form-group mb-2">
          <label translate>global.email</label>
          <input type="text" #email="ngModel" required autocomplete="off" [ngModel]="user?.email" class="form-control"
            [class.is-invalid]="email.invalid && email.touched" name="email">
        </div>

        <!-- Password -->
        <div *ngIf="user.isNew" class="form-group mb-2">
          <label translate>global.password</label>
          <input type="password" #password="ngModel" required autocomplete="off" [ngModel]="user?.password"
            class="form-control" name="password">
        </div>

        <!-- Address -->
        <div class="form-group mb-2">
          <label translate>global.address</label>
          <input type="text" #address="ngModel" autocomplete="off" [ngModel]="user?.address" class="form-control"
            name="address">
        </div>

        <!-- Phone -->
        <div class="form-group mb-2">
          <label translate>global.phone</label>
          <input type="text" #phone="ngModel" autocomplete="off" [ngModel]="user?.phone" class="form-control"
            name="phone">
        </div>

        <app-button *ngIf="user?.isNew" [text]="'global.save'" [loading]="isLoadingForm" (onClick)="onAddUser(userForm)">
        </app-button>
        <app-button *ngIf="!user.isNew" [text]="'global.edit'" [loading]="isLoadingForm" (onClick)="onEdit(userForm)">
        </app-button>

      </form>
    </div>
  </div>
</div>